import React, { useState, useEffect } from 'react';

// Material UI
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// Material UI Icons
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import SaveIcon from '@mui/icons-material/Save';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';


// Componentes 


// Funciones para obtener datos
import ObtenerEspecialidades from '../functions/ObtenerEspecialidades';
import InsertarEspecialidad from '../functions/InsertarEspecialidad';
import GuardarEspecialidad from '../functions/GuardarEspecialidad';

// Tipos de datos
import EspecialidadesTabla from '../types/EspecialidadesTabla';

// Indicador de procesamiento
import CircularProgress from '@mui/material/CircularProgress';

interface EditarEspecialidadProps {
    idEspecialidad: number;
    guardarCambios: (especialidad: EspecialidadesTabla) => void;
    cancelarCambios: () => void;
    eliminando: boolean;
}
  
export const EditarEspecialidad: React.FC<EditarEspecialidadProps> = ({ idEspecialidad, guardarCambios, cancelarCambios, eliminando = false }) => {
  
    const [isLoading, setIsLoading] = useState(true);
    const [especialidad, setEspecialidad] = useState<EspecialidadesTabla | null>(null);
    
    const [errorEspecialidad, setErrorEspecialidad] = useState<string | null>(null);

    const [localId, setLocalId] = useState(0);
    const [localEspecialidad, setLocalEspecialidad] = useState('');
    const [localHabilitado, setLocalHabilitado] = useState('');
    const [localFchCrea, setLocalFchCrea] = useState('');
    const [localFchModi, setLocalFchModi] = useState('');
    const [localDadoBaja, setLocalDadoBaja] = useState('');
    const [localFchBaja, setLocalFchBaja] = useState('');
    
    useEffect(() => {
        
        const fetchEspecialidad = async () => {
            try {

                const data = await ObtenerEspecialidades("",idEspecialidad);
                
                if (data.especialidades_ok === 'si') {

                    // Todo ok, prestador recuperado

                    const EspecialidadRecuperada: EspecialidadesTabla = {
                        id: data.especialidades[0].id,
                        especialidad: data.especialidades[0].especialidad,
                        habilitado: data.especialidades[0].habilitado,
                        fecha_creacion: data.especialidades[0].fecha_creacion,
                        fecha_modificacion: data.especialidades[0].fecha_modificacion,
                        dado_de_baja: data.especialidades[0].dado_de_baja,
                        fecha_baja: data.especialidades[0].fecha_baja
                    };

                    setEspecialidad(EspecialidadRecuperada);

                    setLocalId(data.especialidades[0].id);
                    setLocalEspecialidad(data.especialidades[0].especialidad);
                    setLocalHabilitado(data.especialidades[0].habilitado);
                    setLocalFchCrea(data.especialidades[0].fecha_creacion);
                    setLocalFchModi(data.especialidades[0].fecha_modificacion);
                    setLocalDadoBaja(data.especialidades[0].dado_de_baja);
                    setLocalFchBaja(data.especialidades[0].fecha_baja);

                    setErrorEspecialidad(null);
                } else {
                    
                    // Hubo errores al recuperar la pregunta frecuente
                    setErrorEspecialidad(data.mensaje);
                    setLocalId(0);
                    setEspecialidad(null);
                    setLocalEspecialidad('');
                    setLocalHabilitado('');
                    setLocalFchCrea('');
                    setLocalFchModi('');
                    setLocalDadoBaja('');
                    setLocalFchBaja('');
                }

                setIsLoading(false);
                                
            } catch (err) {
                setErrorEspecialidad('Error al obtener la información de la especialidad.');
                setLocalId(0);
                setEspecialidad(null);
                setLocalHabilitado('');
                setLocalFchCrea('');
                setLocalFchModi('');
                setLocalDadoBaja('');
                setLocalFchBaja('');

                setIsLoading(false);
            }
        };

        if (idEspecialidad > 0) {
            // Estoy editando una especialidad
            fetchEspecialidad();
        } else {
            // Estoy creando una nueva especialidad
            setIsLoading(false);
            setEspecialidad({id:0, especialidad:'', habilitado:'', fecha_creacion:'', fecha_modificacion:'', dado_de_baja:'', fecha_baja:''});
            setLocalId(0);
            setLocalEspecialidad('');
            setLocalFchCrea('');
            setLocalFchModi('');
            setLocalFchBaja('');
            setLocalHabilitado('S');
            setLocalDadoBaja('N');
        }

    }, []);

    const handleChangeLocalEspecialidad = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalEspecialidad(event.target.value.toUpperCase());
    };


    const handleChangeLocalHabitado = (event: SelectChangeEvent) => {
        let valor = event.target.value;
        let valorMayuscula = valor.toUpperCase();
        setLocalHabilitado(valorMayuscula);
    };

    const handleChangeLocalDadoBaja = (event: SelectChangeEvent) => {
        let valor = event.target.value;
        let valorMayuscula = valor.toUpperCase();
        setLocalDadoBaja(valorMayuscula);
    };

    
    const guardarCambiosLocal = async () => {

        if (idEspecialidad === 0) {
            // Crear nueva especialidad

            const EspecialidadNueva: EspecialidadesTabla = {
                id: 0,
                especialidad: localEspecialidad,
                habilitado: localHabilitado,
                fecha_creacion: '',
                fecha_modificacion: '',
                dado_de_baja: 'N',
                fecha_baja: ''
            };
            
            try {
                const especialidadInsertada = await InsertarEspecialidad(EspecialidadNueva);

                if (especialidadInsertada.especialidad_insertada === 'si') {
                    guardarCambios(EspecialidadNueva);
                } else {
                    alert('Error al guardar los cambios: ' + especialidadInsertada.mensaje);
                }
            } catch (error) {
                alert('Error al guardar los cambios: ' + error);
            }
        } else {

            if (eliminando) {
                
                // Se realiza la baja lógica de la especialidad
                // HABILITADO = N
                // DADO_BAJA = S
                const fechaActual = new Date().toISOString();
                const guardarFecha = fechaActual.slice(0, 10)+" "+fechaActual.slice(11, 19);

                // Modificar datos especialidad
                const EspecialidadEditada: EspecialidadesTabla = {
                    id: idEspecialidad,
                    especialidad: localEspecialidad,
                    habilitado: 'N',
                    fecha_creacion: localFchCrea,
                    fecha_modificacion: guardarFecha,
                    dado_de_baja: 'S',
                    fecha_baja: guardarFecha
                };

                const respuesta = await GuardarEspecialidad(EspecialidadEditada);

                if (respuesta.especialidad_guardada === 'si') {
                    guardarCambios(EspecialidadEditada);
                } else {
                    alert('Error al guardar los cambios: ' + respuesta.mensaje);
                }
                
            } else {
                
                // Modificar especialidad
                const fechaActual = new Date().toISOString();
                const guardarFecha = fechaActual.slice(0, 10)+" "+fechaActual.slice(11, 19);
                
                // Modificar datos pregunta frecuente
                const EspecialidadEditada: EspecialidadesTabla = {
                    id: idEspecialidad,
                    especialidad: localEspecialidad,
                    habilitado: localHabilitado,
                    fecha_creacion: localFchCrea,
                    fecha_modificacion: guardarFecha,
                    dado_de_baja: localDadoBaja,
                    fecha_baja: localDadoBaja === 'S' ? guardarFecha : ''
                };

                const respuesta = await GuardarEspecialidad(EspecialidadEditada);

                if (respuesta.especialidad_guardada === 'si') {
                    guardarCambios(EspecialidadEditada);
                } else {
                    alert('Error al guardar los cambios: ' + respuesta.mensaje);
                }
            }
        }
    };
    return (
        <>
            {isLoading && (
                <div>
                    <p className="text-lg">Por favor espere</p>
                    <CircularProgress />
                </div>
            )}
            {(!isLoading && especialidad) && (
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
                    {eliminando ? (
                        <h1 className="font-metropolis text-xl text-red-700 font-bold mb-2">Eliminando Especialidad: {especialidad?.especialidad}</h1>
                    ) : (
                        <h1 className="font-metropolis text-xl font-bold mb-2">{idEspecialidad > 0 ? "Editando Especialidad: " + especialidad?.especialidad : "Nueva Especialidad"}</h1>
                    )}
                    {/* Campos principales */}     
                    <div className="border-t-2 border-vp-azul w-full flex flex-row pt-3 justify-between items-start lg:space-x-2 xxs:flex-wrap xs:flex-wrap sm:flex-wrap md:flex-wrap lg:flex-wrap xl:flex-nowrap xxl:flex-nowrap mb-2">
                        <div className="flex flex-col justify-start items-center max-w-[120px] flex-grow w-full">
                            <TextField id="id" label="Id" variant="outlined" value={localId}
                                sx={{
                                    '& .MuiOutlinedInput-input': {
                                        padding: '8px',
                                    },
                                    '& .MuiInputLabel-outlined': {
                                        top: '-6px',
                                    },
                                    '& .MuiInputLabel-shrink': {
                                        top: '0px',
                                    },
                                    width: '100%',
                                    marginRight: '6px',
                                    marginBottom: '8px',
                                }}
                                disabled
                            />
                        </div>
                        <div className="flex flex-col justify-start items-center max-w-[380px] flex-grow w-full">
                            <TextField id="especialidad" label="Especialidad" variant="outlined" value={localEspecialidad}
                                sx={{
                                    '& .MuiOutlinedInput-input': {
                                        padding: '8px',
                                    },
                                    '& .MuiInputLabel-outlined': {
                                        top: '-6px',
                                    },
                                    '& .MuiInputLabel-shrink': {
                                        top: '0px',
                                    },
                                    width: '100%',
                                    marginRight: '6px',
                                    marginBottom: '8px',
                                }}
                                onChange={handleChangeLocalEspecialidad}
                                disabled={eliminando}
                            />
                        </div>
                        {/* Fechas y habilitado */}
                        {especialidad.id > 0 && (<>
                            <div className="flex flex-col justify-between items-center max-w-[170px] flex-grow w-full">
                                <TextField id="fchcrea" label="Fec. Creado" variant="outlined" value={localFchCrea}
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    disabled
                                />
                            </div>
                            <div className="flex flex-col justify-between items-center max-w-[170px] flex-grow w-full">
                                <TextField id="fchcmodi" label="Fec. Modificado" variant="outlined" value={localFchModi}
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    disabled
                                />
                            </div>                                    
                        </>)
                        }
                        <div className="flex flex-col justify-between items-center max-w-[100px] flex-grow w-full">
                            <FormControl fullWidth sx={{marginRight: '6px',}}>
                                <InputLabel id="label-habilitado"
                                    sx={{top: '-6px',
                                        '&.MuiInputLabel-shrink': {
                                            transform: 'translate(14px, 0px) scale(0.75)',
                                        },
                                    }}
                                    >
                                        Habilitado
                                    </InputLabel>
                                <Select
                                    labelId="label-habilitado"
                                    id="habilitado"
                                    value={localHabilitado}
                                    label="Habilitado"
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    onChange={handleChangeLocalHabitado}
                                    disabled={eliminando}
                                    >
                                    <MenuItem value={'S'}>Si</MenuItem>
                                    <MenuItem value={'N'}>No</MenuItem>
                                </Select>
                            </FormControl> 
                        </div>
                        <div className="flex flex-col justify-between items-center max-w-[100px] flex-grow w-full">
                            <FormControl fullWidth sx={{marginRight: '6px',}}>
                                <InputLabel id="label-dadobaja"
                                    sx={{top: '-6px',
                                        '&.MuiInputLabel-shrink': {
                                            transform: 'translate(14px, 0px) scale(0.75)',
                                        },
                                    }}
                                    >
                                        Baja
                                    </InputLabel>
                                <Select
                                    labelId="label-dadobaja"
                                    id="dadobaja"
                                    value={localDadoBaja}
                                    label="Baja"
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    onChange={handleChangeLocalDadoBaja}
                                    disabled={eliminando}
                                    >
                                    <MenuItem value={'S'}>Si</MenuItem>
                                    <MenuItem value={'N'}>No</MenuItem>
                                </Select>
                            </FormControl> 
                        </div>
                        {localDadoBaja === 'S' && (
                            <div className="flex flex-col justify-between items-center max-w-[170px] flex-grow w-full">
                                <TextField id="fchbaja" label="Fec. Baja" variant="outlined" value={localFchBaja}
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    disabled
                                />
                            </div>)
                        }
                    </div>
                    <div className="flex flex-row justify-end items-center space-x-2">
                        {eliminando ? (
                            <>
                                <button className="mt-3 vp-btn-rojo-sm" onClick={guardarCambiosLocal} ><DeleteForeverIcon /> Eliminar</button>
                                <button className="mt-3 vp-btn-azul-sm" onClick={cancelarCambios} ><SettingsBackupRestoreIcon /> Cancelar</button>
                            </>
                        ) : (
                            <>
                                <button className="mt-3 vp-btn-azul-sm" onClick={guardarCambiosLocal} ><SaveIcon /> Guardar Cambios</button>
                                <button className="mt-3 vp-btn-rojo-sm" onClick={cancelarCambios} ><SettingsBackupRestoreIcon /> Cancelar</button>
                            </>
                        )}
                        
                    </div>
                </div>
            )}
        </>
    );
};
